import { makeStyles } from "@mui/styles";
import { ReactComponent as ConnectionLine1 } from "./connectionline-1.svg";
import { ReactComponent as ConnectionLine2 } from "./connectionline-2.svg";
import { ReactComponent as ConnectionLine3 } from "./connectionline-3.svg";
import { ReactComponent as ConnectionLine4 } from "./connectionline-4.svg";
import { ReactComponent as ConnectionLine5 } from "./connectionline-5.svg";

const connectionLines = [ConnectionLine1, ConnectionLine2, ConnectionLine3, ConnectionLine4, ConnectionLine5];

const useConnectionLineStyles = makeStyles<null, { isOnline: boolean }>({
	root: {
		"& .st0": {
			stroke: (props) => (props.isOnline ? "#4DAE4E" : "#FF9700"),
		},
		"& .st1": {
			stroke: (props) => (props.isOnline ? "#4DAE4E" : "#FF9700"),
		},
		"& .st2": {
			fill: (props) => (props.isOnline ? "#4DAE4E" : "#FF9700"),
		},
	},
});

export const ConnectionLine = (props: { nr: number; isOnline: boolean }) => {
	const classes = useConnectionLineStyles({ isOnline: props.isOnline });

	const C = connectionLines[props.nr];
	return <C className={classes.root} />;
};
